import React from 'react';
import { format } from "date-fns";

const BookingSummary = ({ timeUnavailable, selectedDay, selectedMonth, selectedYear, selectedHour, selectedMinute, numberOfGuests, selectedArea, onChange }) => {
    
    
    var formatedDate = selectedYear + '-' + (selectedMonth + 1).toString().padStart(2, '0') + '-' + selectedDay.toString().padStart(2, '0');

    const dateFormat = (date) => {
        function dateOrdinal(d) {
            return d+(31==d||21==d||1==d?"st":22==d||2==d?"nd":23==d||3==d?"rd":"th")
        };
        var dateString = new Date(date);
        var day = format(dateString, "dd");
        return <div>{format(new Date(dateString), 'EEEE')}, {dateOrdinal(day)} {format(new Date(dateString), 'MMMM yyyy')}</div>
    }

    return (
        <React.Fragment>
            <div className='grid grid-cols-dense lg:flex gap-4 lg:gap-y-6 mb-5'>

                <div className='col-span-3 lg:col-span-1 grow'>
                    <p className="column-header">Date</p>
                    <h5 className="subtitle mb-0">                    
                    {dateFormat(formatedDate)}
                    </h5>
                </div>

                <div className='max-lg:hidden bg-light-gray flex flex-col h-auto w-[1px]'></div>
                
                <div className='grow'>
                    <div className='flex-1 grow lg:px-4'>
                        <p className="column-header">Time</p>
                        <h5 className={`subtitle mb-0 ${timeUnavailable ? 'text-tomato' : ''}`}>{selectedHour}:{selectedMinute}</h5>
                    </div>
                </div>

                <div className='max-lg:hidden bg-light-gray flex flex-col h-auto w-[1px]'></div>
                
                <div className='grow'>
                    <div className='flex-1 grow lg:px-4'>
                        <p className="column-header">Guests</p>
                        <h5 className='subtitle mb-0'>{numberOfGuests} guests</h5>
                    </div>
                </div>

                <div className='max-lg:hidden bg-light-gray flex flex-col h-auto w-[1px]'></div>
                
                {selectedArea?.areaLinkGroup?.areaLinks[0]?.name &&

                    <div className='grow'>
                        <div className='flex-1 grow lg:px-4'>
                            <p className="column-header">Area</p>
                            <h5 className='subtitle mb-0'>{selectedArea.areaLinkGroup.areaLinks[0]?.name}</h5>
                        </div>
                    </div>
                }

                <div className='col-span-3 lg:col-span-1 shrink'>
                    <div className='h-full flex flex-col justify-end'>
                        <button className='button' onClick={() => onChange(1)}>Edit</button>
                    </div>
                </div>

            </div>
            <div className='h-px bg-italian-grey w-full'></div>
        </React.Fragment>
    );

}

export default BookingSummary;